// src/pages/GoogleAuthLoadingPage.js
import React, { useEffect } from 'react';
import axios from 'axios'; // 引入 axios
import { Container, Box, Typography, CircularProgress, CssBaseline } from '@mui/material';

const GoogleAuthLoadingPage = () => {
    useEffect(() => {
        const initiateGoogleAuth = async () => { // 将 useEffect 回调函数改为 async
            try {
                const response = await axios.post("/auth/google"); // 发起 POST 请求到后端
                // 假设后端返回的数据中包含 redirectUrl 字段，指向 Google 认证 URL
                const redirectUrl = response.data.redirectUrl;
                if (redirectUrl) {
                    window.location.href = redirectUrl; // 使用后端返回的 URL 进行重定向
                } else {
                    console.error("后端未返回 Google 认证 URL");
                    //  可以添加错误处理 UI，例如显示错误信息
                }
            } catch (error) {
                console.error("请求 Google 认证接口失败:", error);
                // 可以添加错误处理 UI，例如显示错误信息
            }
        };

        initiateGoogleAuth(); // 调用异步函数
    }, []); //  空依赖数组，只在组件挂载后执行一次

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <CircularProgress sx={{ mb: 2 }} /> {/* Loading indicator */}
                <Typography component="h1" variant="h5" align="center">
                    正在跳转到 Google 验证...
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2 }}>
                    请稍候，您将被重定向到 Google 登录页面进行验证。
                </Typography>
            </Box>
        </Container>
    );
};

export default GoogleAuthLoadingPage;